import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Modal, Typography } from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import { useDispatch, useSelector } from 'react-redux';
import { SET_PIN_PADRON_ALERTAS } from 'store/reducers/caja';
import { useLocation } from 'react-router-dom';

const ModalAlertas = ({ padron, setRestrict }) => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();

  const pinPadronAlertasFromStore = useSelector(({ caja }) => caja.pinPadronAlertas);
  const pinPadronAlertas = padron?.id ? padron : pinPadronAlertasFromStore;

  const alertas = pinPadronAlertas?.alertas || pinPadronAlertas?.alerta || [];
  const restrictivas = alertas.filter((a) => a.es_restrictiva && a.estados_globales !== 5);
  const noRestrictivas = alertas.filter((a) => !a.es_restrictiva && a.estados_globales !== 5);

  const onCancel = () => {
    if (pinPadronAlertas) {
      dispatch({ type: SET_PIN_PADRON_ALERTAS });
    }
    setVisible(false);
  };

  useEffect(() => {
    let mounted = true;
    if (padron) {
      if (setRestrict) {
        const hasRestrictiveAlerts = Boolean(restrictivas.length);
        if (mounted) {
          setRestrict(hasRestrictiveAlerts);
        }
      }

      if (mounted) {
        if (restrictivas.length || noRestrictivas.length) {
          setVisible(true);
        }
      }
    }
    return () => { mounted = false; };
  }, [padron, setRestrict]);

  // Si es visible o
  // Si la ruta es caja o ventanilla y hay un padron seleccionado o hay alertas en el
  // pinPadronAlertas
  const shouldModalBeOpen = visible
    || (((location.pathname.includes('caja') || location.pathname.includes('ventanilla'))
    && (padron?.id || pinPadronAlertas?.id))
    && Boolean(restrictivas.length || noRestrictivas.length || alertas.length));

  if (!padron) {
    return null;
  }

  return (
    <Modal
      open={shouldModalBeOpen}
      closable={false}
      footer={null}
      title={<FormSubmitControls label="Alertas" onCancel={onCancel} onCancelText="Cerrar" />}
      centered
    >
      {!!restrictivas.length && (
        <Col span={24}>
          <Typography.Title level={4}>
            {restrictivas.length > 1 ? 'Alertas restrictivas' : 'Alerta restrictiva'}
          </Typography.Title>
          <ul>
            {restrictivas.map(({ cargosBloqueados = [], ...alerta }) => (
              <li key={alerta.id}>
                <Typography.Text>{`${alerta.folio} - ${alerta.descripcion}`}</Typography.Text>
                {!!cargosBloqueados.length && (
                  <ul>
                    {cargosBloqueados.map((cargo) => (
                      <li key={cargo.id}>
                        <Typography.Text>{`${cargo.tipo_de_cargo.clave} - ${cargo.descripcion}`}</Typography.Text>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
          <br />
          <br />
        </Col>
      )}
      {!!noRestrictivas.length && (
        <Col span={24}>
          <Typography.Title level={4}>
            {noRestrictivas.length > 1 ? 'Alertas informativas' : 'Alerta informativa'}
          </Typography.Title>
          {noRestrictivas.map((r) => (
            <Col key={r.id} span={24}>
              <Typography.Text>{`${r.folio} - ${r.descripcion}`}</Typography.Text>
            </Col>
          ))}
        </Col>
      )}
    </Modal>
  );
};

ModalAlertas.propTypes = {
  padron: PropTypes.shape({
    id: PropTypes.number,
    alerta: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      folio: PropTypes.string,
      descripcion: PropTypes.string,
      es_restrictiva: PropTypes.bool,
      estados_globales: PropTypes.number,
    })),
  }),
  setRestrict: PropTypes.func,
};

ModalAlertas.defaultProps = {
  padron: {
    id: 0,
    alerta: [],
  },
  setRestrict: undefined,
};

export default ModalAlertas;
